import React from "react";

import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    srOnly: {
        position: "absolute",
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        border: 0,
    },
    skipList: {
        position: "absolute",
        top: 0,
        paddingLeft: 0,
        listStyle: "none",
    },
    skip: {
        textTransform: "none",
        fontSize: "clamp(13px, 1vw, 1rem)",
        letterSpacing: "0.01071em",
        position: "absolute",
        left: 1,
        top: 0,
        width: 1,
        height: 0,
        overflow: "hidden",
        zIndex: 999999,
        margin: 0,
        padding: theme.spacing(0, 2),
        borderRadius: 0,
        fontWeight: 400,
        "&:focus": {
            position: "fixed",
            width: "auto",
            height: "auto",
            left: 1,
            top: 0,
            backgroundColor: "#001D77",
            color: "#FFFFFF",
            // fontSize: "0.75rem",
        },
    },
}));

const SkipList = (props) => {
    const { path, name } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    let H1_text = t("Strona główna – RSI");

    if (path?.includes("/rsigestorzy")) H1_text = t("Gestorzy systemów - RSI");
    if (path?.includes("/rsisystemy")) H1_text = t("Systemy informacyjne - RSI");
    if (path?.includes("/rsiobiekty")) H1_text = t("Typy obiektów - RSI");
    if (path?.includes("/rsicechy")) H1_text = t("Cechy informacyjne - RSI");
    if (path?.includes("/sitemap")) H1_text = t("Mapa strony - RSI");
    if (path?.includes("/deklaracja")) H1_text = t("Deklaracja dostępności - RSI");
    if (path?.includes("/polityka-prywatnosci")) H1_text = t("Polityka prywatności - RSI");

    

    const handleSkipLink = (id) => {
        const target = document.getElementById(id);
        if (target) {
            setTimeout(() => {
                target.focus();
                console.log(document.activeElement);
            }, 100);
        }
    };

    return (
        <>
            <h1 className={classes.srOnly}>{name ? `${name} - RSI` : H1_text}</h1>

            <ul className={classes.skipList}>
                <li>
                    <Button
                        className={classes.skip}
                        onClick={() => handleSkipLink("global-main-logo")}
                        tabIndex={0}
                        disableRipple
                        role="link"
                    >
                        {t("Przejdź do menu z nawigacją")}
                    </Button>
                </li>
                <li>
                    <Button
                        className={classes.skip}
                        onClick={() => handleSkipLink("page-content")}
                        tabIndex={0}
                        disableRipple
                        role="link"
                    >
                        {t("Przejdź do treści")}
                    </Button>
                </li>
                <li>
                    <Button
                        className={classes.skip}
                        onClick={() => handleSkipLink("global-footer")}
                        tabIndex={0}
                        disableRipple
                        role="link"
                    >
                        {t("Przejdź do stopki")}
                    </Button>
                </li>
            </ul>
        </>
    );
};

export default SkipList;
